import Material from './Material';
import HotStamping from './HotStamping';
import Printing from './Printing';
import FlexoPrintingAndDieCutting from './FlexoPrintingAndDieCutting';
import GuillotineCutting from './GuillotineCutting';
import Cutting from './Cutting';
import Cellophane from './Cellophane';
import LacquerCoating from './LacquerCoating';
import Glueing from './Glueing';
import Lamination from './Lamination';
import Magnet from './Magnet';
import CoatingLabor from './CoatingLabor';
import Transport from './Transport';
import VCutLabor from './VCutLabor';
import ProfitMargin from './ProfitMargin';
import InsideLaminationMaterial from './InsideLaminationMaterial';
import InsideLaminationPrinting from './InsideLaminationPrinting';
import InsideLaminationLamination from './InsideLaminationLamination';
import InsideLaminationLacquer from './InsideLaminationLacquer';

export {
  Material,
  HotStamping,
  Cutting,
  GuillotineCutting,
  Printing,
  FlexoPrintingAndDieCutting,
  Cellophane,
  LacquerCoating,
  Glueing,
  Lamination,
  Magnet,
  CoatingLabor,
  Transport,
  VCutLabor,
  ProfitMargin,
  InsideLaminationMaterial,
  InsideLaminationPrinting,
  InsideLaminationLamination,
  InsideLaminationLacquer,
};
